export const ITable = React.lazy(() => import(/* webpackChunkName: "ITable" */ './fragments/ITable.react'));
